import {Component, OnInit} from '@angular/core';
import * as _ from 'lodash';

import {GridColumnComponent} from './base-grid-column-component';

@Component({
  selector: 'st-date-column',
  template: `<span title=""
                   class="w-100 d-inline-block"
                   [stDateFormat]="dateFormat"
                   [expectedDateFormat]="expectedDateFormat"
                   [dateStringValue]="dateStringValue"
                   [isDisplayLocalTimezone]=true></span>`
})
export class DateColumnComponent extends GridColumnComponent implements OnInit {
  dateFormat: string;
  expectedDateFormat: string;
  dateStringValue: string;
  ngOnInit() {
    this.dateStringValue = _.get(this.context, this.configPayload.column, '');
    this.dateFormat = this.configPayload.dateFormat ?? '';
    this.expectedDateFormat = this.configPayload.expectedDateFormat ?? '';
  }
}
